import React from "react";
import CanvasJSReact from "@canvasjs/react-charts";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const PieChart = () => {
  const options = {
    animationEnabled: true,
    theme: "dark2",
    backgroundColor: "transparent",
    creditText: "", // Removes the watermark text
    creditHref: "", // Removes the link
    toolTip: {
      enabled: false, // Disable tooltip on hover
    },
    legend: {
      fontSize: 20,
      markerSize: 50, // Increase color box size
      markerMargin: 15, // Add spacing between markers
      horizontalAlign: "center", // Adjust position
      verticalAlign: "bottom",
      maxWidth: 600, // Ensure enough space
      itemWrap: true, // Allow wrapping if needed
    },

    data: [
      {
        type: "doughnut",
        startAngle: 150,
        innerRadius: "50%", 
        indexLabel: "{name} {y}%",
        dataPoints: [
          { name: "Total Infi Sales", y: 35, color: "#715787" },
          {
            name: "Total Reserved for Exchange Liquidity",
            y: 15,
            color: "#353d6e",
          },
          { name: "Reserve Fund", y: 9, color: "#3c6696" },
          { name: "Marketing", y: 6, color: "#86eae8" },
          { name: "@SbSe Protocol Allocation", y: 35, color: "#4691b8" },
        ],
      },
    ],
  };

  return (
    <div>
      {" "}
      {/* Increased size */}
      <CanvasJSChart options={options} />
    </div>
  );
};

export default PieChart;
